// API Configuration
const API_CONFIG = {
    development: {
        baseURL: 'http://localhost:3001',
    },
    production: {
        baseURL: 'https://audiosum.ai',
    }
};

const getApiConfig = () => {
    const environment = process.env.NODE_ENV || 'development';
    return API_CONFIG[environment];
};

export const API_BASE_URL = getApiConfig().baseURL;
export const CONTACT_API_URL = `${API_BASE_URL}/api/contact`;

export default API_CONFIG;